import {
  SET_LOADING,
  GET_COMPASS_CUSTOMERS,
  GET_NON_CUSTOMERS,
  GET_CUSTOMERS_EXPIRATION_COUNTER,
  GET_NON_CUSTOMERS_EXPIRATION_COUNTER,
} from './types'

const initialState = {
  // table to send email
  isLoading: false,
  compassCustomers: {},
  customersExpirationCounter: {},
  nonCustomers: {},
  nonCustomersExpirationCounter: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_NON_CUSTOMERS_EXPIRATION_COUNTER:
      return {
        ...state,
        nonCustomersExpirationCounter: action.payload,
      }
    case GET_CUSTOMERS_EXPIRATION_COUNTER:
      return {
        ...state,
        customersExpirationCounter: action.payload,
      }
    case GET_COMPASS_CUSTOMERS:
      return {
        ...state,
        compassCustomers: action.payload,
        isLoading: false,
      }
    case GET_NON_CUSTOMERS:
      return {
        ...state,
        nonCustomers: action.payload,
        isLoading: false,
      }
    case SET_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    default:
      return state
  }
}
